import React from 'react';
import { useSelector } from 'react-redux';

import { getScrollSelector } from 'modules/app/selectors';

/** @type {React.FC} */
const useScrollTo = () => {
  const scrollTo = useSelector(getScrollSelector);

  React.useLayoutEffect(() => {
    if (scrollTo) {
      document.querySelector(scrollTo)?.scrollIntoView();
    }
  }, [scrollTo]);

  return undefined;
};

export default useScrollTo;
